__webpack_require__.p = "/stone-paper-scissors/";